import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './components/App';
import { watchInstallOffer } from './utils/installApp';

// Before anything is drawn (report 8c5f3514): a browser that will offer to install the chat app says so by firing
// `beforeinstallprompt`, and it fires that once, often while React is still starting. Caught here, the offer is kept
// for the "Install app" button in the chat's top row, which is drawn long afterwards (utils/installApp.ts).
watchInstallOffer();

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode><App /></React.StrictMode>);
